import React from 'react'

function PaymentList() {
  return (
    <div>PaymentList</div>
  )
}

export default PaymentList